import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class AgendasService {

  constructor(
    private http: HttpClient
  ) { }

  consultar(dataInicio: string, dataFim: string, contaId: string, pagina: number) {
    return this.http
      .get(
        urls.apiBase + '/Agendamentos/Consultar?dataInicio=' +
        dataInicio + '&dataFim=' +
        dataFim + '&contaId=' +
        contaId + '&tamanhoPagina=25&indicePagina=' + pagina
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/agendas/agendas.service.ts